<template>
  <div>
    <el-dialog title="请选择课程"
               :visible.sync="dialogFormVisible"
               :close-on-click-modal="false"
               width="1200px"
               @close="emitClose"
               @open="open()">

      <el-form class="search-wrap"
               ref="searchForm"
               :inline="true"
               :model="query">
        <el-form class="search-wrap"
                 ref="searchForm"
                 :inline="true"
                 :model="query">
          <el-form-item label="商品名称"
                        prop="name">
            <el-input v-model="query.product_keyword"
                      placeholder="输入商品名称"
                      @input="getList(query)"
                      clearable></el-input>
          </el-form-item>
          <el-form-item label="商品类型"
                        prop="ref_type">
            <el-select v-model="query.product_types"
                       clearable
                       placeholder="请选择"
                       style="width: 150px"
                       @change="getList(query)">
              <el-option v-for="item in filter.refTypes"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>

        </el-form>
        <!-- <el-form-item label="商品关键字"
                      prop="product_keyword">
          <el-input v-model="query.product_keyword"
                    placeholder="输入商品关键字"
                    clearable
                    @input="getList()"></el-input>
        </el-form-item> -->
        <!-- <el-form-item label="用户"
                      prop="user_keyword">
          <el-input v-model="query.user_keyword"
                    placeholder="输入用户名/手机号"
                    clearable
                    @input="getList()"></el-input>
        </el-form-item> -->

      </el-form>
      <el-table class="table"
                :data="results"
                @selection-change="handleSelectionChange"
                border
                style="width: 100%">
        <el-table-column type="selection"
                         width="50"
                         align="center"
                         fixed="right">
        </el-table-column>
        <el-table-column type="index"
                         label="序号"
                         width="64"
                         align="center">
        </el-table-column>
        <el-table-column prop="code_product_name"
                         label="订单号"
                         width="200"
                         align="center"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            {{ formatOpenCourseCode(scope.row.task_title) }}
          </template>
        </el-table-column>
        <el-table-column prop="code_product_name"
                         label="商品名称"
                         width="320"
                         align="center"
                         show-overflow-tooltip></el-table-column>
        <el-table-column prop="code_product_type"
                         width="120"
                         label="商品类型"
                         align="center">
          <template slot-scope="scope">
            <span v-show="scope.row.code_product_type == '1'">课程</span>
            <span v-show="scope.row.code_product_type == '2'">题库</span>
            <span v-show="scope.row.code_product_type == '3'">专栏</span>
            <span v-show="scope.row.code_product_type == '4'">资料</span>
          </template>
        </el-table-column>
        <el-table-column prop="code_count_total"
                         label="核销进度（已核销/总数）"
                         width="200"
                         align="center">
          <template slot-scope="scope">
            {{scope.row.code_count_exchange_finish}} / {{scope.row.code_count_total}}
          </template>
        </el-table-column>
        <el-table-column label="有效期"
                         min-width="300"
                         align="center">
          <template slot-scope="scope">
            <span>{{$moment(scope.row.start_time).format('YYYY-MM-DD HH:mm')}} 至 {{$moment(scope.row.end_time).format('YYYY-MM-DD HH:mm')}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="create_time"
                         label="创建时间"
                         width="200"
                         align="center">
          <template slot-scope="scope">
            {{ scope.row.create_time | dateFormat("YYYY-MM-DD") }}
          </template>
        </el-table-column>

      </el-table>
      <div class="pagin-box">

        <el-pagination background
                       layout="total, prev, pager, next, sizes, jumper"
                       :current-page="Number(query.pageIndex)"
                       :page-sizes="[10, 20, 50, 100, 500]"
                       :page-size="Number(query.pageSize)"
                       :total="Number(pageTotal)"
                       @size-change="handleSizeChange"
                       @current-change="handlePageChange"></el-pagination>
      </div>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary"
                   @click="handleOpenCourse">确认开课</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import { adminUrl } from '../../../utils/helper'

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    editRow: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },

  data() {
    return {
      dialogFormVisible: this.visible,
      chooseList: [],

      results: [],
      query: {
        pageIndex: 1,
        pageSize: localStorage.getItem('pageSize')
          ? Number(localStorage.getItem('pageSize'))
          : 10,
        isPaging: 1,
      },
      pageTotal: 10,
      start_code_task_id: null,
      filter: {
        refTypes: [
          { label: '课程', value: '1' },
          { label: '题库', value: '2' },
          { label: '专栏', value: '3' },
          { label: '资料', value: '4' },
        ],
      },
      codelist: [],
    }
  },
  mounted() {},
  watch: {
    visible(val) {
      this.dialogFormVisible = val
    },
    editRow(val) {
      this.query.start_code_task_id = val.id
    },
  },
  methods: {
    formatOpenCourseCode(code) {
      // code 格式示例: "加盟商开课码（订单号：260518543579）"
      if (!code) return '-'

      // 匹配括号内的数字
      const match = code.match(/订单号：(\d+)/)
      return match ? match[1] : code
    },
    async handleOpenCourse() {
      // 修复1: 修正拼写错误 length
      if (!this.codelist || this.codelist.length <= 0) {
        this.$message.error('请选择商品')
        return // 修复2: 添加 return，阻止继续执行
      }

      const str = adminUrl()
      let data = {
        start_product_code: this.codelist,
        uid: this.editRow.student_bind_uid,
      }

      try {
        const res = await this.$axios({
          url: `${str}/api/v1/back/product/startProductCode/exchange/withMQExecute`,
          method: 'post',
          data: data,
        })

        console.log('res', res.data)

        // 修复3: 正确判断响应状态
        if (res && res.code == 0) {
          this.$message.success('开课成功')
          this.dialogFormVisible = false // 关闭弹窗
          this.$emit('close') // 触发父组件关闭事件
        } else {
          this.$message.error(res.data?.msg || '开课失败')
        }
      } catch (error) {
        console.error('开课失败：', error)
        this.$message.error('开课失败，请重试')
      }
    },

    async handleSelectionChange(val) {
      this.chooseList = val

      if (!val || val.length === 0) {
        this.codelist = []
        return
      }

      const promises = val.map(async (item) => {
        try {
          const data = {
            pageIndex: 1,
            pageSize: 10,
            isPaging: 1,
            start_code_task_id: item.id,
            exchange_statuses: 0,
          }
          const str = adminUrl()
          const res = await this.$axios({
            url: `${str}/api/v1/back/product/startProductCode/list`,
            method: 'get',
            params: data,
          })

          if (res.data && res.data.list && res.data.list.length > 0) {
            return res.data.list[0].start_product_code
          }
          return null
        } catch (error) {
          console.error('请求失败：', error)
          return null
        }
      })

      const codelist = (await Promise.all(promises)).filter(
        (code) => code !== null
      )
      this.codelist = codelist
      console.log('codelist', this.codelist)
    },
    emitClose() {
      this.query.pageIndex = 1
      this.start_code_task_id = null
      this.results = []
      this.$emit('close')
    },
    async getList() {
      let data = this.query
      let str = adminUrl()
      const res = await this.$axios({
        url: `${str}/api/v1/back/product/startProductCode/task/list`,
        method: 'get',
        params: data,
      })
      this.results = res.data.list
      this.pageTotal = res.data.count
    },
    open() {
      this.getList()
    },
    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, 'pageSize', val)
      localStorage.setItem('pageSize', val)
      this.getList()
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, 'pageIndex', val)
      this.getList()
    },
  },
}
</script>

<style lang="less" scoped>
.input-new-tag {
  width: 90px;
}
.el-tag {
  line-height: 32px;

  height: 32px;
  margin: 0px 5px;
}
.tips {
  font-size: 14px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 16px;
}
.footer {
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
}
.pagin-box {
  margin-top: 10px;
  display: flex;
  justify-content: center;
}
</style>